import * as Sentry from '@sentry/react';

import { RUNTIME_ENV } from '../envConfig';

// Initialize Sentry with minimal config first (no heavy integrations)
Sentry.init({
  dsn: 'https://60645459cb8720a1cd645aac397cd5c2@o322377.ingest.us.sentry.io/4509286103580672',
  sendDefaultPii: true,
  integrations: [],
  environment: RUNTIME_ENV,
  beforeSend: event => {
    if (RUNTIME_ENV !== 'localdev') {
      return event;
    }
    return null;
  },
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (typeof window !== 'undefined') {
  const loadIntegrations = () => {
    Sentry.addIntegration(Sentry.browserTracingIntegration());
    Sentry.addIntegration(Sentry.replayIntegration());
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadIntegrations);
  } else {
    setTimeout(loadIntegrations, 0);
  }
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
